import React from "react";

interface UserRequestCardProps {
  title: string;
  count: number;
  description: string;
  badgeText: string;
  badgeVariant?: "pending" | "approved" | "rejected";
}

const badgeStyles: Record<string, string> = {
  pending: "bg-orange-50 text-orange-600",
  approved: "bg-green-50 text-green-600",
  rejected: "bg-red-50 text-red-600",
};

const UserRequestCard: React.FC<UserRequestCardProps> = ({
  title,
  count,
  description,
  badgeText,
  badgeVariant = "pending",
}) => {
  return (
    <div className="flex flex-col w-1/3  justify-center items-start shadow-md rounded-lg p-4">
      <div className="flex flex-row items-center justify-between w-full">
        <div className="text-2xl">{title}</div>
        <span
          className={`rounded-full px-3 py-1 text-xs font-medium ${badgeStyles[badgeVariant]}`}
        >
          {badgeText}
        </span>
      </div>
      <div className="text-2xl font-bold">{count}</div>
      <p className="text-sm text-muted-foreground">{description}</p>
    </div>
  );
};

export default UserRequestCard;
